import React from 'react';
// @mui
import { Box, CircularProgress, Container, Grid, Typography } from '@mui/material';
// sections
import Form from 'src/sections/voicemail-settings/Form/Form';
// components
import Page from 'src/components/Page';
import PageHeader from 'src/components/PageHeader';
// hooks
import useSettings from 'src/hooks/useSettings';
import AgentLanguageVariantSelect from 'src/sections/voicemail-settings/AgentLanguageVariantSelect';
//queries
import useVoicemailSettings, { VoicemailSettings } from 'src/hooks/core-api/useVoicemailSettings';
// store
import useMainStore from 'src/store';
//

const VoicemailSettingsPage = () => {
  const pageTitle = 'Voicemail Settings';

  const { themeStretch } = useSettings();

  const selectedLocations = useMainStore((state) => state.selectedLocations);
  const voicemailSettingsQuery = useVoicemailSettings({
    location_id: selectedLocations ? selectedLocations[0].id : null,
  });

  const [selectedAlvId, setSelectedAlvId] = React.useState<number>();

  const [selectedAlv, setSelectedAlv] = React.useState<VoicemailSettings | undefined>();

  React.useEffect(() => {
    // Update selectedAlv when voicemailSettingsQuery.data and selectedAlvId change
    if (voicemailSettingsQuery.data && selectedAlvId) {
      const alv = voicemailSettingsQuery.data.find((x) => x.alv_id === selectedAlvId);
      setSelectedAlv(alv);
    }
  }, [voicemailSettingsQuery.data, selectedAlvId]);

  const alvChangeHandler = (alv_id: number) => {
    setSelectedAlvId(alv_id);
  };

  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <PageHeader title={pageTitle} />
            <Typography variant="subtitle1">
              Would you like voicemail notifications sent to your email(s)?
            </Typography>
            {voicemailSettingsQuery.isLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress />
              </Box>
            )}
          </Grid>
          {voicemailSettingsQuery.data && (
            <Grid item xs={12} md={4}>
              <AgentLanguageVariantSelect
                variants={voicemailSettingsQuery.data.map(({ agent_language_code, alv_id }) => ({
                  agent_language_code,
                  alv_id,
                }))}
                onChange={alvChangeHandler}
              />
              {selectedAlv && <Form data={selectedAlv} key={selectedAlv.alv_id} />}
            </Grid>
          )}
        </Grid>
      </Container>
    </Page>
  );
};

export default VoicemailSettingsPage;
